import React, { useState } from 'react'
import GenericForm from '../crud/GenericForm'
import Close from '../../assets/svg/CloseButton.svg'
import { InputField } from '../reusable/InputField'
import StudentItems from '../reusable/StudentItems'
import Loader from '../Live/Loader'

const EnrollStudent = ({
    course,
    entityFields,
    formData,
    handleChange,
    handleSubmit,
    loading,
    onClose,
}) => {
    const courseField = entityFields.find((field) => field.name === 'course_id');
    const studentField = entityFields.find((field) => field.name === 'student_id');

    return (
        <div className="relative p-4 w-full h-[350px] max-w-[90vw] md:max-w-3xl lg:max-w-7xl mx-auto overflow-y-auto">
            <div className="flex justify-between items-center pb-4 mb-4 border-b dark:border-gray-600">
                <h3 className="text-xl md:text-2xl font-semibold text-gray-900 dark:text-white capitalize">
                    Enroll New Student
                </h3>
                <button
                    onClick={onClose}
                    className="p-2 -mr-2 text-gray-400 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-colors dark:hover:bg-gray-600 dark:hover:text-white"
                >
                    <img className="w-6 h-6 md:w-8 md:h-8" src={Close} alt="Close" />
                </button>
            </div>
            <div className='grid gap-4 grid-cols-1 sm:grid-cols-2'>
                <InputField
                    key={courseField.name}
                    name={courseField.name}
                    type={courseField.type}
                    handleChange={handleChange}
                    label={courseField.label}
                    placeholder={courseField.placeholder}
                    value={course.title}
                    options={courseField.options}
                    disabled={true}
                />
                <StudentItems field={studentField} formData={formData} handleChange={handleChange} courseId={course.id} studentsNotInCourse={true} />
            </div>

            <div className="flex justify-end mt-16">
                <button
                    className="w-full sm:w-auto px-6 py-3 text-base bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                    disabled={loading}
                    onClick={handleSubmit}
                >
                    {loading ? <Loader /> : 'Save'}
                </button>
            </div>
        </div>
    )
}

export default EnrollStudent
